// CLINICS creates clashes in naming so we will use CLINICS_MANAGER
export const DEFAULT_CLINICS_MANAGER_API_VERSION = 'v1'

export const ENDPOINT_CLINICS_MANAGER_TIMEZONES = `/api/clinics/*/timezones`
export const ENDPOINT_CLINICS_MANAGER_CLINICS = `/api/clinics/*/clinics`
export const ENDPOINT_CLINICS_MANAGER_CLINIC = `/api/clinics/*/clinics/*`
export const ENDPOINT_CLINICS_MANAGER_ORGANIZATIONS = `/api/clinics/*/organizations`
